/* eslint-disable */
import pageLocalesData from './page-locales-data.js'
import _ from 'lodash';
import mergeLocalesData from '@src/global-locales/utils/merge-locales-data.js';

/**
 * @returns {pageLocalesData}
 */
const getPageLocalesData = () => {
  return mergeLocalesData(pageLocalesData);
}

const applyLocalesTemplateArgs = (text, args) => {
  const replaceArgsList = text.match(/\{([^}]+)\}/ig) || [];
  let replaceList = {};
  if(typeof args === 'object') {
    replaceList = Object.keys(args).reduce((list, key) => {
      return {...list, [`{${key}}`] : args[key]}
    } , {});
  };
  return replaceArgsList.reduce((text, key) => {
    return text.replaceAll(key, replaceList[key] || '');
  },text || '');
}

const getLocales = (path, args) => {
  if(!path) {return 'place enter path'}
  const localesData = getPageLocalesData();
  const currentLocale = _.get(localesData, path) || '';
  const replaceArgsList = currentLocale.match(/\{([^}]+)\}/ig) || [];
  let replaceList = {};
  if(typeof args === 'object') {
    replaceList = Object.keys(args).reduce((list, key) => {
      return {...list, [`{${key}}`] : args[key]}
    } , {});
  };
  return replaceArgsList.reduce((text, key) => {
    return text.replaceAll(key, replaceList[key] || '');
  },currentLocale || '');
}

const getLocalesForHtml = (path, args) => {
  const text = getLocales(path,args);
  return <span dangerouslySetInnerHTML={{__html: text}}></span>
}


//"{second} {hahaha}（s）后自动关闭".match(/\{([^}]+)\}/ig)

export default getPageLocalesData;
export {
  getLocales,
  getLocalesForHtml,
  applyLocalesTemplateArgs
}
